function initTextColumnsCarousel(container) {
  const sliders = container.querySelectorAll(".text-columns-carousel__slider");
  if (sliders.length === 0) return;

  sliders.forEach((slider) => {
    // Prevent double initialization
    if (slider.classList.contains('flickity-enabled')) {
       return;
    }

    const flkty = new Flickity(slider, {
      cellAlign: "left",
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      groupCells: true,
      adaptiveHeight: false // We will handle this manually for groupCells
    });

    const updateHeight = () => {
      if (window.innerWidth >= 768) {
        flkty.viewport.style.transition = '';
        return;
      }
      if (!flkty.selectedSlide) return;
      let maxHeight = 0;
      flkty.selectedSlide.cells.forEach(cell => {
        if (cell.element.offsetHeight > maxHeight) {
          maxHeight = cell.element.offsetHeight;
        }
      });
      flkty.viewport.style.height = maxHeight + 'px';
      flkty.viewport.style.transition = 'height 0.3s ease';
    };

    flkty.on('select', updateHeight);
    flkty.on('resize', updateHeight);
    // Initial height update
    setTimeout(updateHeight, 100);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initTextColumnsCarousel(document);
});

document.addEventListener("shopify:section:load", function (event) {
  initTextColumnsCarousel(event.target);
});
